// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/hooks/useReveal.ts
// Version: v1.6.0
// Beschreibung: Reveal über inline-styles - versteckt NUR Elemente außerhalb des Viewports

interface RevealOptions {
  once?: boolean;
  durationMs?: number;
  offset?: number;
}

const defaultOptions: RevealOptions = {
  once: true,
  durationMs: 800,
  offset: 100,
};

export const initReveal = (options: RevealOptions = {}): (() => void) => {
  const config = { ...defaultOptions, ...options };
  const processedElements = new WeakSet<Element>();

  // Prüft ob Element im Viewport ist
  const isInViewport = (el: HTMLElement): boolean => {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight + 50 && rect.bottom > -50;
  };

  // Element verarbeiten
  const processElement = (el: HTMLElement) => {
    if (processedElements.has(el)) return;
    processedElements.add(el);

    // Transition setzen
    el.style.transition = `opacity ${config.durationMs}ms ease-out, transform ${config.durationMs}ms ease-out`;

    // WICHTIG: Nur verstecken wenn NICHT im Viewport!
    if (isInViewport(el)) {
      // Im Viewport → sichtbar lassen, .visible hinzufügen
      el.classList.add("visible");
    } else {
      // Außerhalb → über inline-style verstecken
      el.style.opacity = "0";
      el.style.transform = "translateY(40px)";
    }
  };

  // Scroll-Handler
  const handleScroll = () => {
    document.querySelectorAll<HTMLElement>(".reveal:not(.visible)").forEach((el) => {
      if (isInViewport(el)) {
        // In Viewport gescrollt → sichtbar machen
        el.classList.add("visible");
      }
    });
  };

  // Polling für dynamisch geladene Elemente
  const pollInterval = setInterval(() => {
    document.querySelectorAll<HTMLElement>(".reveal").forEach((el) => {
      if (!processedElements.has(el)) {
        processElement(el);
      }
    });
  }, 300);

  // Initial verarbeiten
  setTimeout(() => {
    document.querySelectorAll<HTMLElement>(".reveal").forEach(processElement);
  }, 100);

  // Scroll-Listener
  window.addEventListener("scroll", handleScroll, { passive: true });

  // Cleanup
  return () => {
    clearInterval(pollInterval);
    window.removeEventListener("scroll", handleScroll);
  };
};

export const useReveal = (options: RevealOptions = {}) => {
  return initReveal(options);
};

export default initReveal;
